import { render, staticRenderFns } from "./NewsGroup.vue?vue&type=template&id=77e07599&scoped=true&"
import script from "./NewsGroup.vue?vue&type=script&lang=js&"
export * from "./NewsGroup.vue?vue&type=script&lang=js&"
import style0 from "./NewsGroup.vue?vue&type=style&index=0&id=77e07599&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e07599",
  null
  
)

export default component.exports